import { MGPValidators } from '../utils/MGPValidator';
import { NumberConfig } from './NumberConfig';
import { RulesConfigDescription } from './RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from './RulesConfigDescriptionLocalizable';
export class RulesConfigDescriptions {
    static GOBAN = new RulesConfigDescription({
        name: () => $localize `Default`,
        config: {
            width: new NumberConfig(19, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            height: new NumberConfig(19, RulesConfigDescriptionLocalizable.HEIGHT, MGPValidators.range(1, 99)),
        },
    });
}
